<!-- Help: the export guide and the FAQ. The head and the foot stay; the body between them scrolls. -->
<div class="help">
  <header class="help__head">
    <div class="help__tabs" role="tablist" aria-label="Help" (keydown)="onTabsKeydown($event)">
      <button class="help__tab" id="render-help-tab-guide" type="button" role="tab" aria-controls="render-help-panel" [class.is-on]="tab === 'guide'" [attr.aria-selected]="tab === 'guide'" [attr.tabindex]="tab === 'guide' ? 0 : -1" (click)="selectTab('guide')">Export guide</button>
      <button class="help__tab" id="render-help-tab-faq" type="button" role="tab" aria-controls="render-help-panel" [class.is-on]="tab === 'faq'" [attr.aria-selected]="tab === 'faq'" [attr.tabindex]="tab === 'faq' ? 0 : -1" (click)="selectTab('faq')">Questions</button>
    </div>
    <button class="help__close" type="button" aria-label="Close" (click)="close()">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M1.5 1.5l11 11M12.5 1.5l-11 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>
    </button>
  </header>

  <div #body class="help__body" id="render-help-panel" role="tabpanel" [attr.aria-labelledby]="'render-help-tab-' + tab">
    <ng-container *ngIf="tab === 'guide'; else questions">
      <h2 class="help__title">Send your textures along</h2>
      <p class="help__lead">Pack them into the FBX, or drop them with it in one folder. Otherwise the model renders without them.</p>
      <p *ngIf="exporter" class="help__from">
        <svg width="12" height="12" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 8.6 6 12.4 14 3.8" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Your file was exported from {{ exporter.label }}
      </p>

      <div class="help__apps" role="tablist" aria-label="Your 3D app" (keydown)="onTabsKeydown($event)">
        <button *ngFor="let item of apps; trackBy: trackByApp" class="help__app" type="button" role="tab" aria-controls="render-help-steps" [class.is-on]="item.id === app.id" [attr.aria-selected]="item.id === app.id" [attr.tabindex]="item.id === app.id ? 0 : -1" (click)="selectApp(item)">{{ item.label }}</button>
      </div>

      <div id="render-help-steps" class="help__guide">
        <p *ngIf="app.intro" class="help__intro">{{ app.intro }}</p>
        <ol *ngIf="app.steps.length" class="help-steps">
          <li *ngFor="let step of app.steps; let i = index" #stepItem class="help-step" [class.has-shot]="!!step.shot" [class.is-spotlit]="spotlight === i">
            <span class="help-step__mark" [class.is-check]="step.check" aria-hidden="true">
              <ng-container *ngIf="!step.check; else tick">{{ i + 1 }}</ng-container>
            </span>
            <div class="help-step__text">
              <p><strong>{{ step.title }}</strong> {{ step.text }}</p>
              <p *ngIf="step.aside" class="help-step__aside"><strong>{{ step.aside.title }}</strong> {{ step.aside.text }}</p>
            </div>
            <figure *ngIf="step.shot as shot" class="help-step__shot">
              <img [src]="shot.src" [width]="shot.width" [height]="shot.height" [alt]="shot.alt" decoding="async">
              <span *ngFor="let mark of shot.marks" class="help-step__ring" [style.left.%]="mark.left" [style.top.%]="mark.top" [style.width.%]="mark.width" [style.height.%]="mark.height" aria-hidden="true"></span>
            </figure>
          </li>
        </ol>
      </div>

      <details class="help__carry">
        <summary>What an FBX can’t carry</summary>
        <div class="help__carry-body">
          <p>It keeps image textures on the standard channels:</p>
          <ul class="help__chips">
            <li *ngFor="let channel of keeps">{{ channel }}</li>
          </ul>
          <p>It drops:</p>
          <ul class="help__loses">
            <li *ngFor="let item of loses"><strong>{{ item.what }}.</strong> {{ item.text }} <span *ngIf="item.fix" class="help__fix">{{ item.fix }}</span></li>
          </ul>
          <p>PNG, TGA and TIFF keep transparency and lose no detail. JPG is fine for color.</p>
        </div>
      </details>
    </ng-container>

    <ng-template #questions>
      <h2 class="help__title">A few good questions.</h2>
      <details *ngFor="let item of faq; let first = first" class="help-faq" [open]="first">
        <summary>{{ item.question }}</summary>
        <p>{{ item.guide ? item.answer + ' ' : item.answer }}<button *ngIf="item.guide" class="help-faq__guide" type="button" (click)="selectTab('guide')">Export guide</button></p>
      </details>
    </ng-template>
  </div>

  <footer class="help__foot">Still stuck? Write to <a class="help__mail" [href]="'mailto:' + supportEmail">{{ supportEmail }}</a> with the file’s name.</footer>
</div>

<ng-template #tick>
  <svg width="12" height="12" viewBox="0 0 16 16" fill="none"><path d="M1 8.94753L5.2 13.1475L15 3.34753" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>
</ng-template>
